import * as React from 'react';
import { Datagrid, ListProps, TextField } from 'react-admin';
import './CoachGuideCategoryDatagrid.scss';
import { TranslateField } from '../components/TranslateField';

export const CoachGuideCategoryDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="coach-guide-categories-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<TextField source="id" label="#"/>
			<TextField source="name" label="NAME"/>
			<TranslateField source="language" label="LANGUAGE"/>
		</Datagrid>
	);
};
